import { CustomerUserAgent } from './customer-user-agent.model';
import { AddEditRacf } from './add-edit-racf.model';

export interface BusinessUnitRef {
    businessUnitId: number;
    isPrimaryBusinessUnit: boolean;
}

export class ApplicationUserDetail {
    public id: number;
    public userName: string;
    public password: string;
    public userNameUnqualified: string;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public active: boolean;
    public email: string;
    public phoneNumber: string;
    public endDate: Date;

    public racfs: AddEditRacf[] = [];
    public customerUserAgents: CustomerUserAgent[] = [];
    public businessUnits: BusinessUnitRef[] = [];
    public teamIds: number[] = [];
    public roleIds: number[] = [];
}
